import { Option } from "@inrev/core";
import { DateTime } from "luxon";
import { type FC } from "react";
import { FinancialPeriodBundle } from "../hooks/useFinancialsMetrics";
import { getCurrentRatioFYEValue } from "../utils/financialMetricValues";
import { FinancialMetricCard } from "./FinancialMetricCard";

export type CurrentRatioFYECardProps = {
	recentFYE?: FinancialPeriodBundle;
};

export const CurrentRatioFYECard: FC<CurrentRatioFYECardProps> = ({ recentFYE }) => {
	const periodEndDate = recentFYE?.period?.periodEndDate;
	const recentYear = Option.map(periodEndDate, (date) => DateTime.fromISO(date).toFormat("yy"));
	const label = `Current Ratio (FYE${recentYear ? ` '${recentYear}` : ""})`;

	const recentCurrentRatio = getCurrentRatioFYEValue(recentFYE);

	return (
		<FinancialMetricCard testId="current-ratio-fye-card" label={label} value={recentCurrentRatio} />
	);
};
